import workflow from '@banking/ui/lib/workflow';
import { update } from './update';
import { recovery } from '@banking/ui/lib/workflow/experiments';
export { State, createState } from './state';
export { Action, advanceScreenAction, backButtonClickAction, browserHistoryChangeAction, businessManagementScreenUpdateAction, businessTypeScreenUpdateAction, controllingIndividualsScreenUpdateAction, entityTypeScreenUpdateAction, userChangeEntityTypeAction, initializeAction, returnToFlowAction, toggleLoadingAction } from './action';
export { Context, update } from './update';

// This is essentially putting the app into a failed state. When an error is
// thrown we want to let it bubble up and cause the app to error out rather than
// try to swallow it and allow things to continue. Improvements could be made in
// the future to handle errors and retry/resume but for now this is preferable.
function recover(state, _error) {
  // TODO(steckel): Add error handling properties to State and "calculate"
  // error codes for display to the customer and customer support inquiry
  return [{
    ...state,
    loading: false
  }, null];
}
const onboardingKyb = (seed, context) => {
  const w = workflow(update(context), seed);
  return {
    states: w.states.pipe(recovery(recover, context)),
    updates: w.updates,
    emit: w.emit
  };
};
export default onboardingKyb;